export enum EJinyTyp {
    TRANSFORMATION_SUBSIDIARY_TO_BRANCH = 'TRANSFORMATION_SUBSIDIARY_TO_BRANCH',
    REVERSE_TAKEOVER = 'REVERSE_TAKEOVER',
    SPINOFF = 'SPINOFF',
    ABSORPTION = 'ABSORPTION',
    BANCRUPTCY = 'BANCRUPTCY',
    BREAKUP = 'BREAKUP',
    DEMERGER = 'DEMERGER',
    INSOLVENCY = 'INSOLVENCY',
    DISSOLUTION = 'DISSOLUTION',
    VOLUNTARY_ARRANGEMENT = 'VOLUNTARY_ARRANGEMENT',
    LIQUIDATION = 'LIQUIDATION',
    ACQUISITION_BRANCH = 'ACQUISITION_BRANCH',
    TRANSFORMATION_UMBRELLA_TO_STANDALONE = 'TRANSFORMATION_UMBRELLA_TO_STANDALONE',
    MERGERS_AND_ACQUISITIONS = 'MERGERS_AND_ACQUISITIONS',
    TRANSFORMATION_BRANCH_TO_SUBSIDIARY = 'TRANSFORMATION_BRANCH_TO_SUBSIDIARY'
}
